import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]

import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import Filelist from '@/components/Filelist.vue'
import Banner from '@/components/Banner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsShow',
  setup(__props) {

const route = useRoute()
const loading = ref(false)
const news = ref({
  title: null,
  body: null,
  full_buildings: [],
  mainImage: null,
  extraImages: [],
  status: null,
  publish_at: null
})

onMounted(() => {
  getNewsItem()
})

function getNewsItem () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/news/' + route.params.newsId).then((res) => {
    news.value = res.data.data
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Bericht van verhuurder",
            bordered: false,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  (news.value.mainImage)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24,
                        md: 8
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: news.value.mainImage.url,
                            style: {"width":"100%"}
                          }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: news.value.mainImage ? 16 : 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(news.value.title), 1),
                      (news.value.full_buildings.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                            _createTextVNode("Bericht voor: "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value.full_buildings, (building, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: building.id
                              }, [
                                _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1),
                                (index + 1 !== news.value.full_buildings.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " | "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        innerHTML: news.value.body
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 1
                  }, 8, ["md"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]),
          (news.value.extraImages.length)
            ? (_openBlock(), _createBlock(_component_a_card, {
                key: 0,
                title: "Bijlages",
                bordered: false,
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [32,32] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(Filelist, {
                            "media-items": news.value.extraImages
                          }, null, 8, ["media-items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})